export const GET_PRINT_TEMPLATE_BY_ENTITYCONFID = 'EPIC/GET_PRINT_TEMPLATE_BY_ENTITYCONFID';
export const GET_PRINT_TEMPLATE_BY_ENTITYCONFID_SUCCESS = 'EPIC/GET_PRINT_TEMPLATE_BY_ENTITYCONFID_SUCCESS';
export const GET_PRINT_TEMPLATE_BY_ENTITYCONFID_FAILURE = 'EPIC/GET_PRINT_TEMPLATE_BY_ENTITYCONFID_FAILURE';
